<script>
  import { domainName, record, lookupFound } from '../stores.js';
  import DKIMResultRaw from './dkimResultRaw.svelte';
  import DKIMResultAdditional from './dkimResultAdditional.svelte';
  import ContactUsForm from '../ContactUsForm.svelte';
  import DKIMResultNotFound from './dkimResultNotFound.svelte';
  import DKIMShare from './dkimShare.svelte';
  import Sidebar from '../Sidebar.svelte';

  let modifyDkim = false;

  // Function to refresh the page
  function refreshPage(event) {
    event.preventDefault(); // Prevents the default anchor behavior
    location.reload(); // Reloads the page
}
</script>

<section class="tool-banner tool-banner-dkim mb-5">
  <div class="banner"></div>
  <div class="row-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12 m-auto banner-text">
          <h2>View DKIM Record</h2>
          <p>Verify message integrity to ensure content does not change in transit.</p>
          <button on:click={() => window.location.reload()} class ="refresh-page" title="Look Up or Generate DKIM Record">Search New Domain</button><i class="fa-solid fa-arrows-rotate"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 m-auto">
          <div class="result-box">
            <div class="found">
              {#if $lookupFound}
                <ul class="result-heading record-found">
                  <li><h3>DKIM Record Found: {$domainName}</h3></li>
                </ul>
              {:else}
                <ul class="result-heading no-record-found">
                  <li><h3>DKIM Record Not Found: {$domainName}</h3></li>
                </ul>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="record record-dkim">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        {#if $lookupFound}
          <DKIMResultRaw />
          <DKIMResultAdditional />

          <div class="btn-wrap">
            <button on:click|preventDefault={() => modifyDkim = true} disabled={modifyDkim} class="btn btn-1 btn-lg" id="modify-dkim">Modify DKIM Record</button>
            <a href="/resources/dmarc" class="btn btn-1 btn-lg" title="Look Up or Generate DMARC Record">Create DMARC Record</a>
          </div>

          {#if modifyDkim}
            <div class="record-box dkim-modify-form">
              <div id="headingRaw" class="box-label">
                <h5>Modify DKIM Record</h5>
                <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseModify" aria-expanded="true" aria-controls="collapseModify" aria-label="Close"></button>
              </div>
              <div id="collapseModify" class="box-detail" aria-labelledby="headingRaw">
                <ContactUsForm />
              </div>
            </div>
          {/if}
        {:else}
          <DKIMResultNotFound />
        {/if}
      </div>


    </div>
  </div>
</section>

<style>

</style>
